import React from 'react';
import s from './Card.css';
import withStyles from "isomorphic-style-loader/withStyles";
import classNames from 'classnames';

class Card extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        const { children, className, ...other } = this.props;
        return (
            <div className={classNames(s.card, className)} {...other}>
                {children}
            </div>
        );
    }
}

export default withStyles(s)(Card);